/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        04/03/2022 08:52
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

export default class LightboxComponent {
    constructor() {
        $('.hentry a:has(>img):not([target="_blank"]):not("[nolightbox]")').each(function () {
            const href = $(this).attr('href')

            if (href.match(/(.jpg|.jpeg|.png|.gif|.svg|.webp)$/)) {
                if ($(this).data('hc-lightbox') === undefined) {
                    $(this).attr('data-hc-lightbox', 'lightbox')
                }
            } else {
                if (href.indexOf(IRISCollectionTheme.serverUrl) === -1) {
                    $(this).attr('target', '_blank')
                }
            }
        })

        let counter = 0
        $('.hentry .wp-block-image').each(function () {
            counter++
            $(this)
                .find('a:has(>img)')
                .each(function () {
                    if ($(this).data('hc-lightbox') === 'lightbox') {
                        $(this).attr('data-hc-lightbox', `wp-block-image-${counter}`)
                    }
                })
        })

        counter = 0
        $('.hentry .wp-block-gallery').each(function () {
            counter++
            $(this)
                .find('a:has(>img)')
                .each(function () {
                    if ($(this).data('hc-lightbox') === 'lightbox') {
                        $(this).attr('data-hc-lightbox', `wp-block-gallery-${counter}`)
                    }
                })
        })

        if ($('[data-hc-lightbox]').length > 0) {
            import(
                /* webpackChunkName: "scripts/hc_lightbox" */
                /* webpackMode: "weak" */
                '@iris.interactive/handcook/public/scripts/components/lightbox/lightbox.component'
            ).then(({ default: hc_lightbox }) => {
                hc_lightbox()
            })
        }
    }
}
